import styled from 'styled-components'
import { CheckMark } from 'ui/components/CheckMark'

export const InternalCheckMark = styled(CheckMark)`
  margin: 0;
`
